import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { FilterMatchMode } from 'primevue/api'
import { usePlantStore } from "@/store/plant"
import { PlantItem } from "@/models/plant/plant.item"


const __default__ = {
  name: 'PlantList'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['select', 'create'],
  setup(__props, { expose, emit }) {
  expose();

const plant = ref({} as PlantItem)
const filter = ref({
  global: {value: null, matchMode: FilterMatchMode.CONTAINS},
})

const plantStore = usePlantStore()



function onSelectDepartment() {
  emit('select', {
    ...plant.value,
  })
}

const __returned__ = { plant, filter, plantStore, emit, onSelectDepartment }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})